// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableStat_tableContainer__j4g1l","table":"TableStat_table__eX6Mt"};